import React from "react";

const BlankListIcon = ({ isActive, isHovered }) => {
  const fillColor = isActive || isHovered ? "#1D4469" : "#969BA9";

  return (
    <span
    // onMouseEnter={() => setIsHovered(true)}
    // onMouseLeave={() => setIsHovered(false)}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 19 18" fill="none">
        {/* First Path */}
        <path
          d="M9.39909 16C9.20484 16 9.01854 15.928 8.88119 15.7998C8.74383 15.6716 8.66667 15.4977 8.66667 15.3164V2.68359C8.66667 2.50229 8.74383 2.32842 8.88119 2.20022C9.01854 2.07202 9.20484 2 9.39909 2C9.59334 2 9.77963 2.07202 9.91699 2.20022C10.0543 2.32842 10.1315 2.50229 10.1315 2.68359V15.3164C10.1315 15.4977 10.0543 15.6716 9.91699 15.7998C9.77963 15.928 9.59334 16 9.39909 16Z"
          fill={fillColor}
        />

        {/* Second Path */}
        <path
          d="M16.2676 9.58941H2.73242C2.53817 9.58941 2.35188 9.51739 2.21452 9.38919C2.07717 9.26099 2 9.08712 2 8.90582C2 8.72452 2.07717 8.55064 2.21452 8.42244C2.35188 8.29424 2.53817 8.22222 2.73242 8.22222H16.2676C16.4618 8.22222 16.6481 8.29424 16.7855 8.42244C16.9228 8.55064 17 8.72452 17 8.90582C17 9.08712 16.9228 9.26099 16.7855 9.38919C16.6481 9.51739 16.4618 9.58941 16.2676 9.58941Z"
          fill={fillColor}
        />
      </svg>
    </span>
  );
};

export default BlankListIcon;
